// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/webhooks/v1/webhooks.proto" (package "c1.api.webhooks.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { WebhookInstanceService } from "./webhooks";
import type { WebhookInstancePayloadGetResponse } from "./webhooks";
import type { WebhookInstancePayloadGetRequest } from "./webhooks";
import type { WebhookInstanceServiceListResponse } from "./webhooks";
import type { WebhookInstanceServiceListRequest } from "./webhooks";
import { WebhooksSearch } from "./webhooks";
import type { WebhooksSearchResponse } from "./webhooks";
import type { WebhooksSearchRequest } from "./webhooks";
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { WebhooksService } from "./webhooks";
import type { WebhooksServiceUpdateResponse } from "./webhooks";
import type { WebhooksServiceUpdateRequest } from "./webhooks";
import type { WebhooksServiceCreateResponse } from "./webhooks";
import type { WebhooksServiceCreateRequest } from "./webhooks";
import type { WebhooksServiceAttemptsResponse } from "./webhooks";
import type { WebhooksServiceAttemptsRequest } from "./webhooks";
import type { WebhooksServiceListResponse } from "./webhooks";
import type { WebhooksServiceListRequest } from "./webhooks";
import type { WebhooksServiceTestResponse } from "./webhooks";
import type { WebhooksServiceTestRequest } from "./webhooks";
import type { WebhooksServiceDeleteResponse } from "./webhooks";
import type { WebhooksServiceDeleteRequest } from "./webhooks";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { WebhooksServiceGetResponse } from "./webhooks";
import type { WebhooksServiceGetRequest } from "./webhooks";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.webhooks.v1.WebhooksService
 */
export interface IWebhooksServiceClient {
    /**
     * @generated from protobuf rpc: Get(c1.api.webhooks.v1.WebhooksServiceGetRequest) returns (c1.api.webhooks.v1.WebhooksServiceGetResponse);
     */
    get(input: WebhooksServiceGetRequest, options?: RpcOptions): UnaryCall<WebhooksServiceGetRequest, WebhooksServiceGetResponse>;
    /**
     * @generated from protobuf rpc: Delete(c1.api.webhooks.v1.WebhooksServiceDeleteRequest) returns (c1.api.webhooks.v1.WebhooksServiceDeleteResponse);
     */
    delete(input: WebhooksServiceDeleteRequest, options?: RpcOptions): UnaryCall<WebhooksServiceDeleteRequest, WebhooksServiceDeleteResponse>;
    /**
     * @generated from protobuf rpc: Test(c1.api.webhooks.v1.WebhooksServiceTestRequest) returns (c1.api.webhooks.v1.WebhooksServiceTestResponse);
     */
    test(input: WebhooksServiceTestRequest, options?: RpcOptions): UnaryCall<WebhooksServiceTestRequest, WebhooksServiceTestResponse>;
    /**
     * @generated from protobuf rpc: List(c1.api.webhooks.v1.WebhooksServiceListRequest) returns (c1.api.webhooks.v1.WebhooksServiceListResponse);
     */
    list(input: WebhooksServiceListRequest, options?: RpcOptions): UnaryCall<WebhooksServiceListRequest, WebhooksServiceListResponse>;
    /**
     * @generated from protobuf rpc: Attempts(c1.api.webhooks.v1.WebhooksServiceAttemptsRequest) returns (c1.api.webhooks.v1.WebhooksServiceAttemptsResponse);
     */
    attempts(input: WebhooksServiceAttemptsRequest, options?: RpcOptions): UnaryCall<WebhooksServiceAttemptsRequest, WebhooksServiceAttemptsResponse>;
    /**
     * @generated from protobuf rpc: Create(c1.api.webhooks.v1.WebhooksServiceCreateRequest) returns (c1.api.webhooks.v1.WebhooksServiceCreateResponse);
     */
    create(input: WebhooksServiceCreateRequest, options?: RpcOptions): UnaryCall<WebhooksServiceCreateRequest, WebhooksServiceCreateResponse>;
    /**
     * @generated from protobuf rpc: Update(c1.api.webhooks.v1.WebhooksServiceUpdateRequest) returns (c1.api.webhooks.v1.WebhooksServiceUpdateResponse);
     */
    update(input: WebhooksServiceUpdateRequest, options?: RpcOptions): UnaryCall<WebhooksServiceUpdateRequest, WebhooksServiceUpdateResponse>;
}
/**
 * @generated from protobuf service c1.api.webhooks.v1.WebhooksService
 */
export class WebhooksServiceClient implements IWebhooksServiceClient, ServiceInfo {
    typeName = WebhooksService.typeName;
    methods = WebhooksService.methods;
    options = WebhooksService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Get(c1.api.webhooks.v1.WebhooksServiceGetRequest) returns (c1.api.webhooks.v1.WebhooksServiceGetResponse);
     */
    get(input: WebhooksServiceGetRequest, options?: RpcOptions): UnaryCall<WebhooksServiceGetRequest, WebhooksServiceGetResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<WebhooksServiceGetRequest, WebhooksServiceGetResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Delete(c1.api.webhooks.v1.WebhooksServiceDeleteRequest) returns (c1.api.webhooks.v1.WebhooksServiceDeleteResponse);
     */
    delete(input: WebhooksServiceDeleteRequest, options?: RpcOptions): UnaryCall<WebhooksServiceDeleteRequest, WebhooksServiceDeleteResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<WebhooksServiceDeleteRequest, WebhooksServiceDeleteResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Test(c1.api.webhooks.v1.WebhooksServiceTestRequest) returns (c1.api.webhooks.v1.WebhooksServiceTestResponse);
     */
    test(input: WebhooksServiceTestRequest, options?: RpcOptions): UnaryCall<WebhooksServiceTestRequest, WebhooksServiceTestResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<WebhooksServiceTestRequest, WebhooksServiceTestResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: List(c1.api.webhooks.v1.WebhooksServiceListRequest) returns (c1.api.webhooks.v1.WebhooksServiceListResponse);
     */
    list(input: WebhooksServiceListRequest, options?: RpcOptions): UnaryCall<WebhooksServiceListRequest, WebhooksServiceListResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<WebhooksServiceListRequest, WebhooksServiceListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Attempts(c1.api.webhooks.v1.WebhooksServiceAttemptsRequest) returns (c1.api.webhooks.v1.WebhooksServiceAttemptsResponse);
     */
    attempts(input: WebhooksServiceAttemptsRequest, options?: RpcOptions): UnaryCall<WebhooksServiceAttemptsRequest, WebhooksServiceAttemptsResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<WebhooksServiceAttemptsRequest, WebhooksServiceAttemptsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Create(c1.api.webhooks.v1.WebhooksServiceCreateRequest) returns (c1.api.webhooks.v1.WebhooksServiceCreateResponse);
     */
    create(input: WebhooksServiceCreateRequest, options?: RpcOptions): UnaryCall<WebhooksServiceCreateRequest, WebhooksServiceCreateResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<WebhooksServiceCreateRequest, WebhooksServiceCreateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Update(c1.api.webhooks.v1.WebhooksServiceUpdateRequest) returns (c1.api.webhooks.v1.WebhooksServiceUpdateResponse);
     */
    update(input: WebhooksServiceUpdateRequest, options?: RpcOptions): UnaryCall<WebhooksServiceUpdateRequest, WebhooksServiceUpdateResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<WebhooksServiceUpdateRequest, WebhooksServiceUpdateResponse>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service c1.api.webhooks.v1.WebhooksSearch
 */
export interface IWebhooksSearchClient {
    /**
     * @generated from protobuf rpc: Search(c1.api.webhooks.v1.WebhooksSearchRequest) returns (c1.api.webhooks.v1.WebhooksSearchResponse);
     */
    search(input: WebhooksSearchRequest, options?: RpcOptions): UnaryCall<WebhooksSearchRequest, WebhooksSearchResponse>;
}
/**
 * @generated from protobuf service c1.api.webhooks.v1.WebhooksSearch
 */
export class WebhooksSearchClient implements IWebhooksSearchClient, ServiceInfo {
    typeName = WebhooksSearch.typeName;
    methods = WebhooksSearch.methods;
    options = WebhooksSearch.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Search(c1.api.webhooks.v1.WebhooksSearchRequest) returns (c1.api.webhooks.v1.WebhooksSearchResponse);
     */
    search(input: WebhooksSearchRequest, options?: RpcOptions): UnaryCall<WebhooksSearchRequest, WebhooksSearchResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<WebhooksSearchRequest, WebhooksSearchResponse>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service c1.api.webhooks.v1.WebhookInstanceService
 */
export interface IWebhookInstanceServiceClient {
    /**
     * @generated from protobuf rpc: List(c1.api.webhooks.v1.WebhookInstanceServiceListRequest) returns (c1.api.webhooks.v1.WebhookInstanceServiceListResponse);
     */
    list(input: WebhookInstanceServiceListRequest, options?: RpcOptions): UnaryCall<WebhookInstanceServiceListRequest, WebhookInstanceServiceListResponse>;
    /**
     * @generated from protobuf rpc: GetPayload(c1.api.webhooks.v1.WebhookInstancePayloadGetRequest) returns (c1.api.webhooks.v1.WebhookInstancePayloadGetResponse);
     */
    getPayload(input: WebhookInstancePayloadGetRequest, options?: RpcOptions): UnaryCall<WebhookInstancePayloadGetRequest, WebhookInstancePayloadGetResponse>;
}
/**
 * @generated from protobuf service c1.api.webhooks.v1.WebhookInstanceService
 */
export class WebhookInstanceServiceClient implements IWebhookInstanceServiceClient, ServiceInfo {
    typeName = WebhookInstanceService.typeName;
    methods = WebhookInstanceService.methods;
    options = WebhookInstanceService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: List(c1.api.webhooks.v1.WebhookInstanceServiceListRequest) returns (c1.api.webhooks.v1.WebhookInstanceServiceListResponse);
     */
    list(input: WebhookInstanceServiceListRequest, options?: RpcOptions): UnaryCall<WebhookInstanceServiceListRequest, WebhookInstanceServiceListResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<WebhookInstanceServiceListRequest, WebhookInstanceServiceListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetPayload(c1.api.webhooks.v1.WebhookInstancePayloadGetRequest) returns (c1.api.webhooks.v1.WebhookInstancePayloadGetResponse);
     */
    getPayload(input: WebhookInstancePayloadGetRequest, options?: RpcOptions): UnaryCall<WebhookInstancePayloadGetRequest, WebhookInstancePayloadGetResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<WebhookInstancePayloadGetRequest, WebhookInstancePayloadGetResponse>("unary", this._transport, method, opt, input);
    }
}
